import "@/App.css";
import BlastNova from "@/components/BlastNova";

function App() {
    return (
        <div className="App">
            <BlastNova />
        </div>
    );
}

export default App;
